import { ReactNode } from 'react';
import { FoldersNavDrawer, TFolder, TPath } from '@modules/items';
import { Path } from '@shared/components';
import { useFolderPathAsBreadcrumbs } from '@shared/hooks';

type TProps = {
  folder: TFolder;
  fullPath: TPath;
  selectedValue: string;
  children: ReactNode; // main content (dialogs + preview page)
  maxWidth?: string; // optional max width for the content area (default: max-w-screen-2xl)
};

const DetectionScaffold = ({ folder, fullPath, selectedValue, children, maxWidth }: TProps) => {
  return (
    <div className="flex flex-1 h-full">
      <FoldersNavDrawer folder={folder} fullPath={fullPath} selectedValue={selectedValue} />
      <div className="grow h-full w-full relative">
        <div className="absolute top-0 left-0 w-full h-full overflow-y-auto">
          <div className={`relative flex flex-col space-y-3 pt-4 pb-16 pl-5 pr-8 ${maxWidth || 'max-w-screen-2xl'}`}>
            <div className="md:pr-64">
              <Path items={useFolderPathAsBreadcrumbs(fullPath)} hasCurrent size="large" />
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetectionScaffold;
